import React from 'react';
import useGetSectionInfo from 'editor/components/FormContent/Field/hooks/useGetSectionInfo';
import extractSettings from 'common/utils/extractSettings';

const withSettings = WrappedComponent => {
    return props => {
        const { id: sectionId, type, isSelected, ...other } = props;
        const settings = extractSettings(type, useGetSectionInfo(sectionId).settings);
        const Section = (
            <WrappedComponent
                isSelected={isSelected}
                sectionId={sectionId}
                type={type}
                {...settings}
                {...other}
            />
        );
        return Section;
    };
};

export default withSettings;
